<template>
  <div class="trip-list">
    <ul class="trip-list_container">
      <li
        v-for="(item, index) in list"
        :key="item.DeviceId"
        :class="{'trip-list_item': true, 'active': activeKey === item.VDeviceId }"
        @click="handlerActive(item)"
      >
        <div class="trip-list_item_name">
          <span class="item_index">{{ index + 1 }}</span>
          <span class="item_name">{{ item.DeviceName }}{{ item.IsDel ? ' (' + $t('iftttset.alreadydelete') + ')' : '' }}</span>
        </div>
        <div class="trip-list_item_contral">
          <!-- 请输入灯珠数量 -->
          <el-input
            v-if="isCustomize && values.hasOwnProperty(item.VDeviceId) && !item.IsDel"
            v-model="values[item.VDeviceId]"
            class="trip-list_item_contral-lampCount"
            :placeholder="$t('sceneCard.lightTripInputLampCount')"
            size="medium"
            @input="e => onAddLamp(item.VDeviceId)"
            @blur="e => onAddLamp(item.VDeviceId)"
          />
          <template v-if="!item.IsDel">
            <el-button
              class="contral_btn btn-identify"
              @click="() => onIdentify(item)"
            >
              <!-- 识别 -->
              {{ $t('sync.identification') }}
            </el-button>
            <el-button
              class="contral_btn btn-up"
              :disabled="index === 0"
              @click="() => onUp(index)"
            >
              <!-- 上移 -->
              {{ $t('iftttset.upmove') }}
            </el-button>
            <el-button
              class="contral_btn btn-down"
              :disabled="index === list.length - 1 || (list[index + 1] && !!list[index + 1].IsDel)"
              @click="() => onDown(index)"
            >
              <!-- 下移 -->
              {{ $t('iftttset.downmove') }}
            </el-button>
          </template>
        </div>
      </li>
    </ul>
    <el-dialog
      class="imgDialog"
      width="30%"
      :modal-append-to-body="false"
      :title="$t('devicecard.dowarn')"
      :visible="identifyDialogData.visible"
      @close="onHandleClose"
    >
      <img
        class="Dialogimg"
        :src="identifyDialogData.imgSrc"
      >
      <div class="Dialogimg">
        {{ identifyDialogData.desc }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { alerterror } from "@/assets/js/common.js";
import { GetIdentifyInfo, PositiveIdentify } from '@/axios/IDevice'
import { postWebIOSocket } from '@assets/socket';
import { catchRequireErr } from "@utils/utils";
import { LAMP_LAYOUT_SERVICE_MODE } from  "@/components/DrawCanvas/enums/index";

export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    directionType: {
      type: Number,
      default: 1
    },
    canvasInitData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // 识别弹窗
      identifyDialogData: {
        imgSrc: '',
        desc: '',
        visible: false
      },
      values: {},
      activeKey: null,
    }
  },

  computed: {
    isCustomize() {
      return this.directionType === 3
    }
  },

  mounted() {
    this.initCustomize();
  },

  methods: {
    initCustomize() {
      if (!this.isCustomize) return;

      const modeData = (this.canvasInitData || {}).modeData || {};

      const idValues = {};

      this.list.forEach(device => {
        const VDeviceId = device.VDeviceId;
        const lampData = modeData[VDeviceId] || {};
        let value = ''

        if (lampData.l && lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.AVERAGE) {
          value = lampData.l.c;
        }

        if (lampData.l && lampData.l.m === LAMP_LAYOUT_SERVICE_MODE.SIMGLE_LINE_AVERAGE && lampData.l.l) {
          value = lampData.l.l.join(',');
        }

        idValues[VDeviceId] = value;
      })

      this.values = idValues;

      const firstDevice = this.list[0];

      if (firstDevice) {
        this.setActiveKey(firstDevice.VDeviceId);
        this.$emit('onTripActive', firstDevice.VDeviceId);
      };
    },

    setActiveKey(VDeviceId) {
      this.activeKey = VDeviceId;
    },


    // emitLampValue(VDeviceId) {
    //   const countStr = this.values[VDeviceId];
    //   const isRegValue = /^(\d+,?)+$/g.test(countStr);

    //   if (countStr.trim() === '') {

    //     // return {
    //     //   lampCount: 0, lampInfoList: null
    //     // }
    //   }

    //   if (!isRegValue) {
    //     this.values[VDeviceId] = this.values[VDeviceId].replace(/[^\d|\,]/g, '');

    //     return;
    //   }
    //   const realValue = this.values[VDeviceId];
    //   let lampCount = 0;
    //   let lampInfoList = null;
    //   const MAX = 500;

    //   if (realValue.includes(',')) {
    //     lampInfoList = realValue.split(',').map(item => Math.min(Number(item) || 0, MAX));

    //     lampCount = lampInfoList.reduce((a, b) => a + b)
    //   } else {
    //     lampCount = Math.min(Number(realValue) || 0 , MAX);
    //   }

    // },

    onAddLamp(VDeviceId) {
      const countStr = `${this.values[VDeviceId]}`;
      const isRegValue = /^(\d+,?)+$/g.test(countStr);
console.log('VDeviceId', VDeviceId,countStr );

      if (countStr.trim() === '') {
        this.$emit('onAddLamp', VDeviceId, 0);
      }

      if (!isRegValue) {
        this.values[VDeviceId] = countStr.replace(/[^\d|\,]/g, '');

        return;
      }
      const realValue = `${this.values[VDeviceId]}`;
      let lampCount = 0;
      let lampInfoList = null;
      const MAX = 500;

      if (realValue.includes(',')) {
        lampInfoList = realValue.split(',').map(item => Number(item) || 0);

        lampCount = lampInfoList.reduce((a, b) => a + b)
      } else {
        lampCount = Math.min(Number(realValue) || 0 , MAX);
      }

      this.$emit('onAddLamp', VDeviceId, lampCount, lampInfoList);
    },

  
    handlerActive(item) {
      const { VDeviceId, IsDel } = item;

      if (!this.isCustomize || IsDel) return;

      this.setActiveKey(VDeviceId);
      this.$emit('onTripActive', VDeviceId);

      this.onAddLamp(VDeviceId)

      // const lampCount = this.values[VDeviceId];

      // if (lampCount) {
      //   this.$emit('onAddLamp', VDeviceId, lampCount);
      // }
    },
    // 上移
    onUp(clickIndex) {
      if (clickIndex === 0) return;

      const replaceIndex = clickIndex - 1;
      const clickItem = this.list[clickIndex];
      const replaceItem = this.list[replaceIndex];
      const newList = [...this.list];

      newList[replaceIndex] = clickItem;
      newList[clickIndex] = replaceItem;

      this.$emit('onSort', newList);
    },
    // 下移
    onDown(clickIndex) {
      if (clickIndex === this.list.length -1) return;

      const replaceIndex = clickIndex + 1;
      const clickItem = this.list[clickIndex];
      const replaceItem = this.list[replaceIndex];
      const newList = [...this.list];

      newList[replaceIndex] = clickItem;
      newList[clickIndex] = replaceItem;

      this.$emit('onSort', newList);
    },

    // 识别
    onIdentify(item) {
      const para = { classSku: item.ClassSku, channelId: item.ChannelId };

      GetIdentifyInfo(para, this.reqIdentifyInfo, item);
    },

    /* 获得设备的识别方式接口返回数据处理
    * rs：接口原始数据包
    * para：传递的参数
    * model：设备对象
    */
    reqIdentifyInfo (res, para, model) {
      if (res.StatusCode === this.$store.state.rightStatusCode) {
        // 去识别
        this.doPositiveIdentify(res.Result, model);
      } else {
        alerterror(this, res.StatusCode);
      }
    },

    /* 去识别设备
    * result：接口原始数据包
    * model：设备对象
    */
    doPositiveIdentify (res, model) {
      if (!res) return;

      if (
        [1, 2].includes(res.IdentifyType)
      ) {
        this.dosocket(model);
        this.showDialog(res, model);
      } else {
        const para = {
          mac: model.Mac,
          deviceId: model.VDeviceId,
          channelId: model.ChildId || model.ChannelId
        }

        if (!para.mac || !para.deviceId || !para.channelId) return;
        PositiveIdentify(para, this.reqPositiveIdentify, model);
      }
    },

      // 展示弹窗
    showDialog(result, model) {
      const imgSrc = this.getDialogImgUrl(result, model);

      this.identifyDialogData = {
        ...this.identifyDialogData,
        imgSrc,
        desc: result.IntroDesc,
        visible: true
      };
    },

    // 关闭弹窗
    onHandleClose() {
      this.identifyDialogData = {
        imgSrc: '',
        desc: '',
        visible: false
      };
    },

    /* 注册socket
      * model：设备对象
      */
    dosocket(model) {
      const para = {
        data: [
          {
            projectCode: this.$store.state.projectcode,
            type: 3,
            id: model.Mac,
          },
        ],
      };

      postWebIOSocket("sync_info_add_event", para);
    },

    /**
     * 识别后弹窗图片
     * @param {*} model
     * @param {*} result
     */
    getDialogImgUrl(model, result) {
      if (model.VDeviceId === '0x02000308') {
        return require('@static/device/identify/nonev2.png');
      } else if (
        result.IntroImage == "" ||
        result.IntroImage == null ||
        result.IntroImage.startsWith("http")
      ) {
        return require('@static/device/identify/none.png');
      } else {
        return catchRequireErr(() => require('@static/device/identify/' + result.IntroImage));
      }
    },
    /* 识别设备处理方法
      * rs：接口返回的原始数据包
      * para：向接口传递的参数
      * model：当前识别的设备对象
      */
    reqPositiveIdentify(res, para, model) {
      if (
        res.StatusCode === this.$store.state.rightStatusCode
      ) {
        model.isflicker = true;

        setTimeout(() => {
          model.isflicker = false;
        }, 2000);

      } else {
        alerterror(this, res.StatusCode);
      }
    },

    resetValues() {
      const idValues = {};

      this.list.forEach(device => {
        idValues[device.VDeviceId] = '';
      })

      this.values = idValues;

      const firstDevice = this.list[0];

      if (firstDevice) {
        this.setActiveKey(firstDevice.VDeviceId);
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.trip-list {
  width: 100%;
  margin-top: 40px;

  .trip-list_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 19px;
    margin-bottom: 8px;
    background: #F4F5F8;
    border: 1px solid #E0E3E6;

    &.active {
      background-color: #DEE8FC;
    }

    .trip-list_item_contral {
      display: flex;
    }

    .trip-list_item_contral-lampCount {
      width: 140px;
      margin-right: 56px;
    }

    .trip-list_item_name {
      span:first-child {
        padding-right: 25px;
      }

      .item_index {
        font-size: 10px;
        font-weight: 400;
        color: #409EFF;
      }

      .item_name {
        font-size: 12px;
        font-weight: 400;
        color: #0042A6;
      }
    }

    .btn-identify {
      margin-right: 45px;
    }
  }
}

</style>
